
import { supabase } from '../client';
import { isValidUUID } from '@/lib/utils';

/**
 * Añade una nueva empresa al sistema
 */
export async function addCompany(companyData: { 
  name: string; 
  description?: string; 
  status: string; 
  contactEmail?: string; 
  contactPerson?: string;
}) {
  try {
    // Transformar camelCase a snake_case para la API de Supabase
    const formattedData = {
      name: companyData.name,
      description: companyData.description,
      status: companyData.status,
      contact_email: companyData.contactEmail,
      contact_person: companyData.contactPerson
    };

    const { data, error } = await supabase
      .from('companies')
      .insert([formattedData])
      .select();
    
    if (error) throw error;
    if (!data || data.length === 0) throw new Error('No se devolvieron datos al crear la empresa');
    
    return data[0];
  } catch (error) {
    console.error('Error al crear empresa:', error);
    throw error;
  }
}

/**
 * Actualiza el tema de una empresa
 */
export async function updateCompanyTheme(companyId: string, theme: {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  logoUrl?: string;
  customCss?: string;
}) {
  try {
    // Asegurarnos de que companyId es un UUID válido
    if (!isValidUUID(companyId)) {
      console.error('Invalid UUID format for company ID:', companyId);
      throw new Error('El ID de la empresa no es un UUID válido');
    }
    
    // Transformar camelCase a snake_case para la API de Supabase
    const themeData = {
      primary_color: theme.primaryColor,
      secondary_color: theme.secondaryColor,
      accent_color: theme.accentColor,
      logo_url: theme.logoUrl,
      custom_css: theme.customCss,
      updated_at: new Date().toISOString()
    };
    
    // Check if theme exists first
    const { data: existingTheme } = await supabase
      .from('company_themes')
      .select('id')
      .eq('company_id', companyId)
      .single();
    
    if (existingTheme) {
      // Update existing theme
      const { data, error } = await supabase
        .from('company_themes')
        .update(themeData)
        .eq('company_id', companyId)
        .select();
      
      if (error) throw error;
      return data;
    } else {
      // Create new theme
      const { data, error } = await supabase
        .from('company_themes')
        .insert([{
          company_id: companyId,
          ...themeData
        }])
        .select();
      
      if (error) throw error;
      return data;
    }
  } catch (error) {
    console.error('Error al actualizar tema de empresa:', error);
    throw error;
  }
}
